<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Ringkasan Pembayaran</div>
									<v-checkbox v-model="paySummary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailLetter" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Alamat Supplier</div>
									<v-checkbox v-model="supplierAddress" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Produk Summary</div>
									<v-checkbox v-model="productSummary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn large depressed color="cyan darken-2 white--text" class="col-12 mt-5" @click="printDiv(detailRetur.por_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="light-blue lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5" id="section-to-print">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="7" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="5" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1 text-uppercase">Retur</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<div class="mt-3" v-if="paySummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="light-blue lighten-5">
														<tr>
															<th colspan="2" class="text-body-2 black--text text-left font-weight-bold">Ringkasan Pembayaran</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>Total Belanja</td>
															<td class="text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row class="pb-3">
											<v-col cols="6" class="pb-0"></v-col>
											<v-col cols="6" class="pb-0">
												<v-card outlined class="pa-4 light-blue lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="pb-3" v-if="detailLetter">
										<div class="border-topbot-dotted py-3 mt-3">
											<v-row>
												<v-col cols="6" class="pb-0">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2 font-weight-bold">Nomor</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2 font-weight-bold">{{ detailRetur.por_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="6">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Atas nama</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailRetur.por_status_created_user_name }}</span>
														</v-col>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Tanggal</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailRetur.por_status_created_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="6">
													<v-row>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Warehouse</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailRetur.warehouse_name }}</span>
														</v-col>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Telephone</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailRetur.warehouse_mobilephone }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="supplierAddress">
										<v-card outlined class="mt-3">
											<v-row class="py-3">
												<v-col cols="6" class="py-0">
													<div class="pl-4 text-body-2 font-weight-bold">Alamat Warehouse</div>
													<div class="pl-4 pt-2 text-body-2">{{ addresText }}</div>
												</v-col>
												<v-col cols="6" class="py-0 border-left-grey">
													<div v-if="detailRetur.por_status == 'rejected'">
														<div class="pl-4 text-body-2">
															<span>Tanggal Pembatalan</span>
															<span class="pl-4">: {{ detailRetur.por_status_rejected_datetime | tanggal }}</span>
														</div>
													</div>
													<div v-else>
														<v-row>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="text-body-2">
																	<span>Tanggal Approve</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailRetur.por_status_approved_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Proses</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailRetur.por_status_processed_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Selesai</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailRetur.por_status_returned_datetime | tanggal }}</span>
																</div>
															</v-col>
														</v-row>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="mt-3" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="light-blue lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Jumlah</th>
															<th class="text-center">Berat</th>
															<th class="text-right">Harga (Rp)</th>
															<th class="text-right">Subtotal (Rp)</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailRetur.por_detail" :key="product.por_detail_id">
															<td class="text-left">{{ product.por_detail_product_name }}</td>
															<td class="text-center">
																<div v-if="detailRetur.por_status == 'created' || detailRetur.por_status == 'rejected'">
																	{{ product.por_detail_quantity_requested }}
																</div>
																<div v-else>{{ product.por_detail_quantity_approved }}</div>
															</td>
															<td class="text-center">{{ product.por_detail_product_weight | toKg }}</td>
															<td class="text-right">{{ product.por_detail_product_price | toNumber }}</td>
															<td class="text-right">
																<div v-if="detailRetur.por_status == 'created' || detailRetur.por_status == 'rejected'">
																	{{ (parseInt(product.por_detail_product_price) * parseInt(product.por_detail_quantity_requested)) | toNumber }}
																</div>
																<div v-else>
																	{{ (parseInt(product.por_detail_product_price) * parseInt(product.por_detail_quantity_approved)) | toNumber }}
																</div>
															</td>
														</tr>
														<tr>
															<td colspan="4" class="font-weight-bold text-right">Total Harga</td>
															<td class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row>
											<v-col cols="6" class="pb-0"></v-col>
											<v-col cols="6" class="pb-0">
												<v-card outlined class="pa-4 light-blue lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="mt-3" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div class="pt-2 text-body-2">
											<div v-if="detailRetur.por_note">{{ detailRetur.por_note }}</div>
											<div v-else>Tidak ada catatan</div>
										</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			paySummary: true,
			detailLetter: true,
			supplierAddress: true,
			productSummary: true,
			note : true,
		}
	},
	computed: {
		...mapState('returSupplier', ['detailRetur']),
		...mapState('commonSupplier', ['letterHeader']),

		addresText() {
			var data = []
			if (this.detailRetur) {
				if (this.detailRetur.warehouse_address)
					data.push(this.detailRetur.warehouse_address)
				if (this.detailRetur.warehouse_subdistrict_name)
					data.push(this.detailRetur.warehouse_subdistrict_name)
				if (this.detailRetur.warehouse_city_name)
					data.push(this.detailRetur.warehouse_city_name)
				if (this.detailRetur.warehouse_province_name)
					data.push(this.detailRetur.warehouse_province_name)
			}
			return data.join(', ')
		},
		grandTotal(){
			let total = 0
			if (this.detailRetur.por_detail) {
				if (this.detailRetur.por_status == 'approved') {
					this.detailRetur.por_detail.forEach( (el) => {
						total += el.por_detail_product_price * el.por_detail_quantity_approved
					});
				} else {
					this.detailRetur.por_detail.forEach( (el) => {
						total += el.por_detail_product_price * el.por_detail_quantity_requested
					});
				}
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		},
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.payMethod = true
				this.detailLetter = true
				this.paySummary = true
				this.supplierAddress = true
				this.productSummary = true
				this.note  = true
			}
		}
	},
};
</script>